/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrUpdateCryptoWithdrawalAddressDto } from '../models/CreateOrUpdateCryptoWithdrawalAddressDto';
import type { CryptoWithdrawalAddressDto } from '../models/CryptoWithdrawalAddressDto';
import type { CryptoWithdrawalAddressResponseDto } from '../models/CryptoWithdrawalAddressResponseDto';
import type { WhitelistedCryptoWithdrawalAddressRequestDto } from '../models/WhitelistedCryptoWithdrawalAddressRequestDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class CryptoWithdrawalAddressesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns CryptoWithdrawalAddressResponseDto Created
     * @throws ApiError
     */
    public postApiCryptoWithdrawalAddresses(
        requestBody?: CreateOrUpdateCryptoWithdrawalAddressDto,
    ): CancelablePromise<CryptoWithdrawalAddressResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-withdrawal-addresses',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param currency
     * @returns CryptoWithdrawalAddressDto Success
     * @throws ApiError
     */
    public getApiCryptoWithdrawalAddresses(
        currency?: string,
    ): CancelablePromise<Array<CryptoWithdrawalAddressDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/crypto-withdrawal-addresses',
            query: {
                'currency': currency,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns CryptoWithdrawalAddressDto Success
     * @throws ApiError
     */
    public getApiCryptoWithdrawalAddresses1(
        id: number,
    ): CancelablePromise<CryptoWithdrawalAddressDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/crypto-withdrawal-addresses/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns CryptoWithdrawalAddressResponseDto Success
     * @throws ApiError
     */
    public putApiCryptoWithdrawalAddresses(
        id: number,
        requestBody?: CreateOrUpdateCryptoWithdrawalAddressDto,
    ): CancelablePromise<CryptoWithdrawalAddressResponseDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/crypto-withdrawal-addresses/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public deleteApiCryptoWithdrawalAddresses(
        id: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/crypto-withdrawal-addresses/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns CryptoWithdrawalAddressResponseDto Success
     * @throws ApiError
     */
    public putApiCryptoWithdrawalAddressesWhitelisted(
        id: number,
        requestBody?: WhitelistedCryptoWithdrawalAddressRequestDto,
    ): CancelablePromise<CryptoWithdrawalAddressResponseDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/crypto-withdrawal-addresses/{id}/whitelisted',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
